import axios from "axios";

export const B2BOrderApi = {
    async getListB2BOrder(data) {
        return await axios.post(`/api/B2B/GetListB2BOrder`, data);
    },
    async fetchOrdersFromTicimax(data) {
        return await axios.post(`/api/Netsis/List-order`, data);
    }
}